(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Academy_video"] && !Shopify.designMode) return;
  try {
    

                  



  var swiper_left = new Swiper('.slider_left .swiper-container', {
   slidesPerView: 'auto',
        spaceBetween: 20,
  hashNavigation: {
        watchState: true,
      },
      pagination: {
        el: '.slider_left .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.slider_left .swiper-button-next',
        prevEl: '.slider_left .swiper-button-prev',
      },
    });






  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ReviewsForPages"] && !Shopify.designMode) return;
  try {
    
    
    var swiper = new Swiper('.testimonial-swiper-container', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      pagination: {
        el: '.testimonial-swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blazepod-testimonial"] && !Shopify.designMode) return;
  try {
    
    
    var swiper = new Swiper('.testimonial-swiper-container', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      pagination: {
        el: '',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-feeds"] && !Shopify.designMode) return;
  try {
    

                  



  var swiper_left = new Swiper('.slider_left .swiper-container', {
   slidesPerView: 'auto',
        spaceBetween: 20,
  hashNavigation: {
        watchState: true,
      },
      pagination: {
        el: '.slider_left .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.slider_left .swiper-button-next',
        prevEl: '.slider_left .swiper-button-prev',
      },
    });






  } catch(e) { console.error(e); }
})();
})();
